import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "tooltip"]

  connect() {
    this.input = this.inputTarget
    this.min = this.input.min
    this.max = this.input.max
    this.tooltip = this.tooltipTarget
    this.arrow = this.tooltip.querySelector(".tooltip-arrow")
    this.positionTooltip()
  }

  changed() {
    this.positionTooltip()
  }

  positionTooltip() {
    let innerText = `${this.input.value} ${this.element.dataset.unitPlural}`

    if (this.input.value == 1) {
      innerText = `${this.input.value} ${this.element.dataset.unitSingular}`
    }

    this.tooltip.querySelector("output").innerText = innerText

    let inputRect = this.input.getBoundingClientRect()
    let tooltipRect = this.tooltip.getBoundingClientRect()
    let arrowRect = this.arrow.getBoundingClientRect()

    this.tooltip.style.left =
      (this.input.value - this.input.min)
      / (this.input.max - this.input.min)
      * (inputRect.width - 24)
      - (tooltipRect.width / 2) + 12 + "px"

    this.arrow.style.left = (tooltipRect.width / 2) - (arrowRect.width / 2) + "px"
  }
}
